import {
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS,
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE,
  HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST,
} from '../../../actions/constants/types';

const initialState = {
  distance: '',
  isFetching: false,
};

const assignmentDistanceInfo = (state = initialState, action) => {
  switch (action.type) {
    case HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST:
      return {
        ...state,
        distance: undefined,
        failureMessage: undefined,
        isFetching: true,
      };
    case HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS:
      return {
        ...state,
        distance: action.response.data.distance,
        isFetching: false,
        failureMessage: undefined,
      };
    case HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE:
      return {
        ...state,
        distance: undefined,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default assignmentDistanceInfo;
